/**
 * @author Ahmed Samer
 * @copyright Copyright 2020 by Radivision Inc., CA, USA. All Rights Reserved.
 * @Date: 2019-12-30
 * @description Implementation of the GraphQL mutation to create a user request.
 * @filename verify-claim-profile-user.ts
 */
import { graphql, GraphQLTaggedNode } from "react-relay";

/**
 * The GraphQL mutation to create the user request.
 *
 * @type {GraphQLTaggedNode}
 */
export const VERIFY_CLAIMER_PROFILE_USER_GRAPHQL_MUTATION: GraphQLTaggedNode = graphql`
  mutation verifyClaimProfileUserMutation($input: verifyClaimerUserInput!) {
    verifyClaimProfileUser(input: $input) {
      errors {
        id
        location
      }
      hasErrors
    }
  }
`;
